/**
 * 🧩 ATOMIC J-01 — SAFE JSON PARSER
 * MISSION: Prevent application crashes by safely parsing fetch responses.
 */
export const safeJson = async (response: Response) => {
    try {
        if (typeof response.text !== 'function') {
            // Fallback for mocked fetch environments that only provide .json()
            if (typeof response.json === 'function') {
                return await response.json();
            }
            throw new TypeError('response.text is not a function and response.json is missing');
        }
        
        const text = await response.text();

        if (!text || text.trim() === "") {
            console.warn("[safeJson] Empty response received");
            return null;
        }

        return JSON.parse(text);
    } catch (err) {
        console.error("[safeJson] Failed to parse JSON response:", err);
        return null;
    }
};
